import React from 'react';
import { saveAs } from 'file-saver';

import Button from '@components/Button';

import { IDisplayEditAttachment } from '../Attachment/AttachmentsEditModal';
interface IDownloadButtonProps {
  attachment: IDisplayEditAttachment;
  errMsg?: string;
}

const DownloadButton: React.FunctionComponent<IDownloadButtonProps> = ({ attachment, errMsg }) => {
  const downloadAttachment = () => {
    setTimeout(() => saveAs(attachment.presignedUrl || attachment.fileURL, attachment.fileName), 0);
  };

  return (
    <>
      <div className={'document-view-fallback message'}>
        {errMsg && (
          <div>
            <p>{errMsg}</p>
          </div>
        )}
      </div>
      <div className={'document-view-fallback download-link'}>
        <Button bsStyle={ButtonStyle.PRIMARY} onClick={downloadAttachment} content="Download Attachment" />
      </div>
    </>
  );
};

export default DownloadButton;
